import { render, staticRenderFns } from "./NewMessageButtonHeader.vue?vue&type=template&id=df878094&scoped=true"
import script from "./NewMessageButtonHeader.vue?vue&type=script&lang=js"
export * from "./NewMessageButtonHeader.vue?vue&type=script&lang=js"
import style0 from "./NewMessageButtonHeader.vue?vue&type=style&index=0&id=df878094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df878094",
  null
  
)

export default component.exports